import Model from '../Model'
import moment from "moment/moment";

export default class Defect extends Model {
    setAttributes(attributes) {
        super.setAttributes(attributes)
        this.formattedDate = moment(attributes.createdOn).format('DD/MM/YYYY');
        let tokens = [this.descriptionOfProblem, this.requiredToMakeGood,]
        this.tokens = tokens.join('|').toLowerCase();
    }

    static parseAttributes(attributes = {}) {
        attributes.package = attributes.package?.value
        return attributes
    }

    static async find(packageReference = null, id) {
        const data = await Http.get(route('api.v2.hsqe.defect', [packageReference, id]), {})
        return this.make(data)
    }

    static async all(packageReference = null) {
        const data = await Http.get(route('api.v2.hsqe.defect.list', [packageReference]))
        return this.make(data)
    }

    static async create(packageReference, attributes) {
        const url = route('api.v2.hsqe.defect.create', [packageReference, attributes.id])
        let payload = this.parseAttributes(attributes);
        const o = await Http.post(url, payload)
    }

    getNotesUrl() {
        return route('api.v2.hsqe.defect.notes.list', [this.packageReference, this.id]);
    }

    postNotesUrl() {
        return route('api.v2.hsqe.defect.notes.store', [this.packageReference, this.id]);
    }

    async update(attributes = {}) {
        const url = route('api.v2.hsqe.defect.store', [this.packageReference, this.id])
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        const o = await Http.put(url, payload)
    }

    async delete() {
        await Http.delete(route('api.v2.hsqe.defect.destroy', [this.packageReference, this.id]))
    }

    async reopen() {
        await this.update({complete: false})
        const data = await Http.get(route('api.v2.hsqe.defect', [this.packageReference, this.id]))
        Object.assign(this, data)
    }

    async markComplete() {
        await this.update({complete: true})
        const data = await Http.get(route('api.v2.hsqe.defect', [this.packageReference, this.id]))
        Object.assign(this, data)
    }

    async send(attributes = {}) {
        const url = route('api.v2.hsqe.defect.send', [this.packageReference, this.id])
        let success
        try {
            success = await Http.post(url, attributes)
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.defect', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

    async revoke(sendRequestId) {
        const url = route('api.v2.hsqe.defect.revoke', [this.packageReference, this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.defect', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

    async resend(sendRequestId) {
        const url = route('api.v2.hsqe.defect.resend', [this.packageReference, this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.defect', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

}
